// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 04/8/2025
const groupActionTypes = {
	/***************	Create A New Group  ******************/
	ADD_GROUP_DETAILS_START: 'add_group_details_start',
	ADD_GROUP_DETAILS_SUCCESS: 'add_group_details_success',
	ADD_GROUP_DETAILS_FAILURE: 'add_group_details_failure',
	ADD_GROUP_DETAILS_RESPONSE_RESET: 'add_group_details_response_reset',
	ADD_GROUP_DETAILS_RESPONSE_CHANGED: 'add_group_details_response_changed',
	/*************** End Create A New Group  *******************/

	/*********  Group List With Paginaion - Start  *********/
	GET_GROUP_LIST_START: 'get_group_group_start',
	GET_GROUP_LIST_SUCCESS: 'get_group_group_success',
	GET_GROUP_LIST_FAILURE: 'get_group_group_failure',
	GET_GROUP_LIST_RESPONSE_RESET: 'get_group_group_response_reset',
	GET_GROUP_LIST_RESPONSE_CHANGED: 'get_group_group_response_changed',
	/*********  Group List With Paginaion - End  *********/

	/*************** Get All Group List Based On Location Start ******************/
	FETCH_ALL_GROUP_START: 'fetch_all_group_start',
	FETCH_ALL_GROUP_SUCCESS: 'fetch_all_group_success',
	FETCH_ALL_GROUP_FAILURE: 'fetch_all_group_failure',
	FETCH_ALL_GROUP_RESPONSE_RESET_START: 'fetch_all_group_response_reset',
	FETCH_ALL_GROUP_RESPONSE_CHANGED: 'fetch_all_group_response_changed',
	/*************** Get All Group List Based On Location End ******************/

	/** ***************** FETCH ALL APPROVED MEMBER START *********************** */
	FETCH_ALL_APPROVED_MEMBER_START: 'fetch_all_approved_member_start',
	FETCH_ALL_APPROVED_MEMBER_SUCCESS: 'fetch_all_approved_member_success',
	FETCH_ALL_APPROVED_MEMBER_FAILURE: 'fetch_all_approved_member_failure',
	FETCH_ALL_APPROVED_MEMBER_RESPONSE_RESET_START: 'fetch_all_approved_member_response_reset',
	FETCH_ALL_APPROVED_MEMBER_RESPONSE_CHANGED: 'fetch_all_approved_member_response_changed',
	/** ***************** FETCH ALL APPROVED MEMBER END *********************** */

	/** ***************** GET ALL OFFICER LIST START *********************** */
	GET_ALL_OFFICER_START: 'get_all_officer_start',
	GET_ALL_OFFICER_SUCCESS: 'get_all_officer_success',
	GET_ALL_OFFICER_FAILURE: 'get_all_officer_failure',
	GET_ALL_OFFICER_RESPONSE_RESET: 'get_all_officer_response_reset',
	GET_ALL_OFFICER_RESPONSE_CHANGED: 'get_all_officer_response_changed',
	/** ***************** GET ALL OFFICER LIST END *********************** */

	/** ***************** GET ALL GROUP DETAILS START *********************** */
	GET_ALL_GROUP_DETAILS_START: 'get_all_group_details_start',
	GET_ALL_GROUP_DETAILS_SUCCESS: 'get_all_group_details_success',
	GET_ALL_GROUP_DETAILS_FAILURE: 'get_all_group_details_failure',
	GET_ALL_GROUP_DETAILS_RESPONSE_RESET: 'get_all_group_details_response_reset',
	GET_ALL_GROUP_DETAILS_RESPONSE_CHANGED: 'get_all_group_details_response_changed',
	/** ***************** GET ALL GROUP DETAILS END *********************** */

	/** ***************** GET BRANCH OFFICER LIST START *********************** */
	GET_BRANCH_OFFICER_START: 'GET_BRANCH_OFFICER_START',
	GET_BRANCH_OFFICER_SUCCESS: 'GET_BRANCH_OFFICER_SUCCESS',
	GET_BRANCH_OFFICER_FAILURE: 'GET_BRANCH_OFFICER_FAILURE',
	GET_BRANCH_OFFICER_RESPONSE_RESET: 'GET_BRANCH_OFFICER_RESPONSE_RESET',
	GET_BRANCH_OFFICER_RESPONSE_CHANGED: 'GET_BRANCH_OFFICER_RESPONSE_CHANGED',
	/** ***************** GET BRANCH OFFICER LIST END *********************** */

	/** ***************** UPDATE EXIST GROUP START *********************** */
	UPDATE_EXIST_GROUP_START: 'UPDATE_EXIST_GROUP_START',
	UPDATE_EXIST_GROUP_SUCCESS: 'UPDATE_EXIST_GROUP_SUCCESS',
	UPDATE_EXIST_GROUP_FAILURE: 'UPDATE_EXIST_GROUP_FAILURE',
	UPDATE_EXIST_GROUP_RESPONSE_RESET: 'UPDATE_EXIST_GROUP_RESPONSE_RESET',
	UPDATE_EXIST_GROUP_RESPONSE_CHANGED: 'UPDATE_EXIST_GROUP_RESPONSE_CHANGED',
	/** ***************** UPDATE EXIST GROUP END *********************** */

	/** ***************** REMOVE MEMBER FROM GROUP START *********************** */
	REMOVE_MEMBER_FROM_START: 'REMOVE_MEMBER_FROM_START',
	REMOVE_MEMBER_FROM_SUCCESS: 'REMOVE_MEMBER_FROM_SUCCESS',
	REMOVE_MEMBER_FROM_FAILURE: 'REMOVE_MEMBER_FROM_FAILURE',
	REMOVE_MEMBER_FROM_RESPONSE_RESET: 'REMOVE_MEMBER_FROM_RESPONSE_RESET',
	REMOVE_MEMBER_FROM_RESPONSE_CHANGED: 'REMOVE_MEMBER_FROM_RESPONSE_CHANGED',
	/** ***************** REMOVE MEMBER FROM GROUP END *********************** */

	/** ***************** DELETE GROUP START *********************** */
	DELETE_GROUP_START: 'DELETE_GROUP_START',
	DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
	DELETE_GROUP_FAILURE: 'DELETE_GROUP_FAILURE',
	DELETE_GROUP_RESPONSE_RESET: 'DELETE_GROUP_RESPONSE_RESET',
	DELETE_GROUP_RESPONSE_CHANGED: 'DELETE_GROUP_RESPONSE_CHANGED',
	/** ***************** DELETE GROUP END *********************** */
};

export default groupActionTypes;
